<template>
  <div class="museum" id="museum">
    <div class="header" :style="{backgroundColor:isComing?'#ff3c00':'#fff'}">
      <img src="https://summit-img.geekpark.net/mobile/museum-header-dark.svg" v-show="!isComing">
      <img src="https://summit-img.geekpark.net/mobile/museum-header-light.svg" v-show="isComing">
    </div>
    <div class="introduce">
      <div class="left">
        <img src="https://summit-img.geekpark.net/mobile/museum-title.svg" style="width: 100%">
        <img src="https://summit-img.geekpark.net/05-%E6%9E%81%E5%AE%A2%E5%8D%9A%E7%89%A9%E9%A6%86-logo.svg"
             style="width: 100%">
      </div>
      <div class="right">
        <div class="plan">特别策划</div>
        <p>
          我们希望找到那些曾经带给我们惊喜和感动的科技产品，带你重拾它们迷人的特质。
        </p>
        <p>
          《极客博物馆》已经成为极客之选最受欢迎的栏目之一，它和无数科技爱好者产生了情感共鸣。我们将在 IF X 期间推出特别展览 ——
          情怀之外，你将有机会重新把玩、审视这些经典产品，它们和现代的科技产品又能碰撞出什么火花？敬请关注。
        </p>
      </div>
    </div>
    <img src="https://summit-img.geekpark.net/mobile/museum-products.png" style="width: 100%">
  </div>
</template>

<script>
export default {
  name: 'Museum',
  data () {
    return {
      isComing: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    getElementTop (element) {
      let actualTop = element.offsetTop
      let current = element.offsetParent

      while (current !== null) {
        actualTop += current.offsetTop
        current = current.offsetParent
      }

      return actualTop
    },
    handleScroll () {
      const scrollHeight = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const museumTop = this.getElementTop(document.querySelector('#museum'))
      if (scrollHeight > museumTop - 400) {
        this.isComing = true
      }
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="less">
  .header {
    box-sizing: border-box;
    width: 90vw;
    margin: auto;
    padding: 8vw 0;
    border-top: 1px solid #000;
    border-bottom: 1px solid #000;
    text-align: left;
    transition: background-color .7s;

    img {
      width: 80vw;
      margin-left: 3vw;
    }
  }

  .introduce {
    width: 90vw;
    margin: auto;
    padding: 14vw 0 5vw 0;
    display: flex;
    justify-content: space-between;

    .left {
      flex: 1;
      padding-right: 1vw;

      img:last-of-type {
        margin-top: 35vw;
      }
    }

    .right {
      flex: 1;
      padding-left: 5vw;

      .plan {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 40vw;
        height: 40vw;
        margin-bottom: 7vw;
        border-radius: 20vw;
        color: #fff;
        background-color: #ff3c00;
        font-size: 9vw;
        font-weight: bold;
      }

      p {
        line-height: 1.8;
        text-align: justify;
        font-size: 3.2vw;

        &:last-of-type {
          margin-top: 2em;
        }
      }
    }
  }
</style>
